/* Oct 2026 rebuild (af-rb-* sections): the interactive parts. Each block wires up only when its
   section is on the page. Cart writes go through the same two mechanisms the live theme already
   uses: AfCartPlan (assets/af-cart-plan.js, the kit builder's tested maths) for the sizer, and the
   "fetch-add, refresh the afc drawer panel, open the drawer" sequence from af-featured-product. */
(function () {
  if (window.__afrb) return;
  window.__afrb = true;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var money = function (cents) {
    var fmt = (document.documentElement.dataset.afrbMoney || '€{{amount_with_comma_separator}}');
    return fmt.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, (cents / 100).toFixed(2).replace('.', ','))
              .replace(/\{\{\s*amount\s*\}\}/, (cents / 100).toFixed(2));
  };
  var toastEl, toastT;
  function toast(msg) {
    if (!toastEl) { toastEl = document.createElement('div'); toastEl.className = 'afrb afrb-toast'; toastEl.setAttribute('role', 'status'); document.body.appendChild(toastEl); }
    toastEl.textContent = msg; toastEl.classList.add('is-on'); clearTimeout(toastT);
    toastT = setTimeout(function () { toastEl.classList.remove('is-on'); }, 2800);
  }

  /* Refresh the afc drawer's cart panel from a fresh copy of the page and open it: the drawer's own
     refresh lives in a closure, so the panel swap is replicated (same as af-featured-product). */
  function refreshDrawer() {
    return fetch(window.location.href, { headers: { Accept: 'text/html' } }).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var drawer = document.getElementById('drawer-cart');
      if (drawer) {
        var fp = doc.querySelector('#drawer-cart [data-afc-panel="cart"]'), lp = drawer.querySelector('[data-afc-panel="cart"]');
        if (fp && lp) lp.innerHTML = fp.innerHTML;
        var fc = doc.querySelector('#drawer-cart [data-afc-count]'), lc = drawer.querySelector('[data-afc-count]');
        if (fc && lc) lc.textContent = fc.textContent;
      }
      var a = document.createElement('a'); a.href = '#drawer-cart'; a.style.display = 'none';
      document.body.appendChild(a); a.click(); a.remove();
    });
  }
  function addItems(items, btn) {
    if (btn) btn.classList.add('is-busy');
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { if (!r.ok) throw r; return refreshDrawer(); })
      .catch(function () { toast(document.documentElement.dataset.afrbErr || 'That could not be added. Please try again.'); })
      .then(function () { if (btn) btn.classList.remove('is-busy'); });
  }

  /* kit cards and any [data-afrb-add="variantId"] */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-afrb-add]'); if (!b) return;
    e.preventDefault();
    addItems([{ id: parseInt(b.dataset.afrbAdd, 10), quantity: 1 }], b);
  });

  /* hero: surface picker */
  $$('[data-afrb-hero]').forEach(function (hero) {
    var recs = JSON.parse(hero.dataset.recs || '[]'), out = $('[data-afrb-rec]', hero);
    function pick(id) {
      $$('[data-afrb-surf]', hero).forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.afrbSurf === id); });
      var r = recs.filter(function (x) { return x.id === id; })[0]; if (!r || !out) return;
      var sized = '', acts = '';
      var counts = (r.counts || '').split(',').map(function (n) { return parseInt(n, 10) || 0; });
      if (counts.length === 6 && window.afrbPlanFor && counts.some(function (n) { return n > 0; })) {
        var pl = window.afrbPlanFor(counts);
        sized = ' ' + (hero.dataset.recTpl || '').replace('[m2]', pl.area.toFixed(0)).replace('[kit]', pl.head).replace('[price]', pl.price);
        acts += '<button type="button" class="afrb__btn afrb__btn--light" data-afrb-hero-add="' + pl.items + '">' + (hero.dataset.addLabel || 'Add to cart') + '</button>';
        acts += '<a class="afrb-hero__size" href="#sizer">' + (hero.dataset.sizeLabel || 'Count yours exactly') + ' &darr;</a>';
      } else if (r.url) acts += '<a class="afrb__btn afrb__btn--light" href="' + r.url + '">' + r.cta + '</a>';
      out.innerHTML = '<b>' + r.name + '</b><span>' + r.text + sized + '</span><span class="afrb-hero__acts">' + acts + '</span>';
    }
    hero.addEventListener('click', function (e) {
      var b = e.target.closest('[data-afrb-surf]'); if (b) { pick(b.dataset.afrbSurf); return; }
      var a = e.target.closest('[data-afrb-hero-add]'); if (a) { addItems(JSON.parse(a.dataset.afrbHeroAdd), a); }
    });
    var first = function () { if (recs.length) pick((recs.filter(function (x) { return x.default; })[0] || recs[0]).id); };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { setTimeout(first, 0); }); else setTimeout(first, 0);
    var v = $('video', hero);
    if (v) {
      var mobile = window.matchMedia('(max-width: 760px) and (orientation: portrait)').matches;
      var src = mobile ? (v.dataset.afrbSrcMobile || v.dataset.afrbSrcDesktop) : (v.dataset.afrbSrcDesktop || v.dataset.afrbSrcMobile);
      var poster = mobile ? (v.dataset.afrbPosterMobile || v.dataset.afrbPosterDesktop) : (v.dataset.afrbPosterDesktop || v.dataset.afrbPosterMobile);
      if (poster) v.poster = poster;
      if (src) { v.src = src; if (!reduce) { v.load(); v.play().catch(function () {}); } }
      if (reduce) { v.removeAttribute('autoplay'); v.pause(); }
    }
  });

  /* sizer: the kit builder's maths (theme settings, AfCartPlan) shown in the open, with the add-ons */
  $$('[data-afrb-sizer]').forEach(function (sz) {
    var P = JSON.parse(sz.dataset.p), T = JSON.parse(sz.dataset.t);
    var M2 = sz.dataset.m2.split(',').map(parseFloat), COV = parseFloat(sz.dataset.cov) || 30, ROLL_M = 50;
    var PRESETS = JSON.parse(sz.dataset.presets);
    var st = { counts: (PRESETS[1] || PRESETS[0]).v.slice(), coat2: false, preset: (PRESETS[1] || PRESETS[0]).id, on: {} };
    var last = null;
    function eur(c) { return money(c); }
    function plan() {
      var one = st.counts.reduce(function (a, c, i) { return a + c * M2[i]; }, 0);
      var area = one * (st.coat2 ? 2 : 1);
      var kits = Math.max(1, Math.ceil(area / COV));
      var f = window.AfCartPlan ? AfCartPlan.kitForm(kits) : { doubles: Math.floor(kits / 2), singles: kits % 2 };
      var garages = (st.counts[2] || 0) + (st.counts[3] || 0);
      var lines = [], total = 0;
      if (f.doubles) { lines.push({ b: (f.doubles > 1 ? f.doubles + ' × ' : '') + T.kit2, p: P.p2 * f.doubles, was: 2 * P.p1 * f.doubles, save: (2 * P.p1 - P.p2) * f.doubles }); total += P.p2 * f.doubles; }
      if (f.singles) { lines.push({ b: f.singles > 1 ? f.singles + ' × ' + T.kit1 : T.kit1, p: P.p1 * f.singles }); total += P.p1 * f.singles; }
      var ups = [];
      if (P.tp1 && window.AfCartPlan) {
        var metres = AfCartPlan.edgeMetres(st.counts, M2), r = AfCartPlan.tapeRolls(metres, ROLL_M), rolls = r.singles + 3 * r.triples;
        if (rolls > 0) {
          var items = []; if (r.singles) items.push({ id: P.tp1, quantity: r.singles }); if (r.triples && P.tp3) items.push({ id: P.tp3, quantity: r.triples });
          ups.push({ k: 'tape', b: T.tape, s: T.tape_sub.replace('[n]', rolls).replace('[m]', Math.round(metres)), p: r.singles * P.ptp1 + r.triples * (P.ptp3 || 3 * P.ptp1), items: items });
        }
      }
      if (P.glv) ups.push({ k: 'glv', b: T.glv, s: T.glv_sub, p: P.pglv, items: [{ id: P.glv, quantity: 1 }] });
      if (P.pad && (garages >= 1 || area > 25)) ups.push({ k: 'pad', b: T.pad, s: T.pad_sub, p: P.ppad, items: [{ id: P.pad, quantity: 1 }] });
      if (P.clo) ups.push({ k: 'clo', b: T.clo, s: T.clo_sub, p: P.pclo, items: [{ id: P.clo, quantity: 1 }] });
      var addons = [];
      ups.forEach(function (u) { if (st.on[u.k]) { total += u.p; addons = addons.concat(u.items); } });
      last = { area: area, kits: kits, lines: lines, ups: ups, total: total, addons: addons, cap: kits * COV };
      return last;
    }
    function render() {
      $$('[data-afrb-out]', sz).forEach(function (o) { o.textContent = st.counts[+o.dataset.afrbOut] || 0; });
      $$('[data-afrb-preset]', sz).forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.afrbPreset === st.preset); });
      var sw = $('[data-afrb-coat2]', sz); if (sw) sw.setAttribute('aria-checked', st.coat2);
      var p = plan(), out = $('[data-afrb-result]', sz);
      var head = p.kits === 1 ? T.one : (p.kits === 2 ? T.two : T.many.replace('[n]', p.kits));
      var cov = Math.min(100, p.area / p.cap * 100);
      var html = '<span class="afrb__eyebrow">' + T.your_kit + '</span><div class="afrb-result__big">' + head + '</div>'
        + '<div class="afrb-meter"><i style="width:' + cov.toFixed(0) + '%"></i></div>'
        + '<div class="afrb-result__ms"><span>' + p.area.toFixed(1).replace('.', ',') + ' m²' + (st.coat2 ? ' · ' + T.two_coats_short : '') + '</span><span>' + p.cap + ' m² ' + T.in_kits.replace('[n]', p.kits) + '</span></div>'
        + '<div class="afrb-lines">' + p.lines.map(function (l) { return '<div><span>' + l.b + (l.save ? '<em>' + T.save.replace('[amount]', eur(l.save)) + '</em>' : '') + '</span><span class="afrb__price">' + eur(l.p) + (l.was ? '<s>' + eur(l.was) + '</s>' : '') + '</span></div>'; }).join('')
        + '</div>';
      if (p.ups.length) html += '<div><span class="afrb__eyebrow" style="font-size:1.2rem">' + T.addons + '</span><div class="afrb-ups">' + p.ups.map(function (u) {
        var im = (P.img || {})[u.k] || '';
        return '<button type="button" class="afrb-up" data-afrb-up="' + u.k + '" aria-pressed="' + !!st.on[u.k] + '"><span class="afrb-up__box"><svg viewBox="0 0 24 24"><path d="M20 6 9 17l-5-5"/></svg></span>' + (im ? '<img src="' + im + '" alt="" loading="lazy" width="40" height="40">' : '<span></span>') + '<span><b>' + u.b + '</b><small>' + u.s + '</small></span><strong class="afrb__price">+ ' + eur(u.p) + '</strong></button>';
      }).join('') + '</div></div>';
      html += '<div class="afrb-lines"><div class="afrb-total"><span>' + T.total + '</span><span class="afrb__price">' + eur(p.total) + '</span></div></div>'
        + '<button type="button" class="afrb__btn afrb__btn--light" data-afrb-sizer-add>' + T.add + '</button>'
        + '<p class="afrb-result__note">' + T.note + '</p>'
        + '<div class="afrb-result__links">' + (sz.dataset.builder === 'true' ? '<button type="button" data-af-kb-open>' + T.full_builder + '</button>' : '') + '</div>';
      out.innerHTML = html;
    }
    sz.addEventListener('click', function (e) {
      var t;
      if ((t = e.target.closest('[data-afrb-inc]'))) { st.counts[+t.dataset.afrbInc] = (st.counts[+t.dataset.afrbInc] || 0) + 1; st.preset = ''; render(); return; }
      if ((t = e.target.closest('[data-afrb-dec]'))) { st.counts[+t.dataset.afrbDec] = Math.max(0, (st.counts[+t.dataset.afrbDec] || 0) - 1); st.preset = ''; render(); return; }
      if ((t = e.target.closest('[data-afrb-preset]'))) { var pr = PRESETS.filter(function (x) { return x.id === t.dataset.afrbPreset; })[0]; if (pr) { st.counts = pr.v.slice(); st.preset = pr.id; render(); } return; }
      if ((t = e.target.closest('[data-afrb-coat2]'))) { st.coat2 = !st.coat2; render(); return; }
      if ((t = e.target.closest('[data-afrb-up]'))) { st.on[t.dataset.afrbUp] = !st.on[t.dataset.afrbUp]; render(); return; }
      if ((t = e.target.closest('[data-afrb-sizer-add]'))) {
        if (!window.AfCartPlan) { toast(T.err); return; }
        t.classList.add('is-busy');
        fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
          var updates = AfCartPlan.builderPlan(c.items, last.kits, { v1: P.v1, v2: P.v2, dk: P.dk }, last.addons);
          return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates: updates }) });
        }).then(function (r) { if (!r.ok) throw r; return refreshDrawer(); })
          .catch(function () { toast(T.err); })
          .then(function () { t.classList.remove('is-busy'); });
      }
    });
    window.afrbPlanFor = function (counts) {
      var one = counts.reduce(function (a, c, i) { return a + c * (M2[i] || 0); }, 0);
      var kits = Math.max(1, Math.ceil(one / COV));
      var f = window.AfCartPlan ? AfCartPlan.kitForm(kits) : { doubles: Math.floor(kits / 2), singles: kits % 2 };
      var total = P.p2 * f.doubles + P.p1 * f.singles, items = [];
      if (f.doubles) items.push({ id: P.v2, quantity: f.doubles });
      if (f.singles) items.push({ id: P.v1, quantity: f.singles });
      return { area: one, kits: kits, head: kits === 1 ? T.one : (kits === 2 ? T.two : T.many.replace('[n]', kits)), price: eur(total), items: JSON.stringify(items) };
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', render); else render();
  });

  /* drag to apply: the pad on the rail, scrubbed by the customer's finger */
  $$('[data-afrb-apply]').forEach(function (st) {
    var v = $('video', st), bar = $('[data-afrb-bar]', st), drag = false;
    if (!v) return;
    if (reduce) { v.removeAttribute('autoplay'); v.pause(); }
    function to(x) { var r = st.getBoundingClientRect(), p = Math.min(1, Math.max(0, (x - r.left) / r.width)); if (v.duration) v.currentTime = p * v.duration; }
    st.addEventListener('pointerdown', function (e) { drag = true; st.classList.add('is-dragging'); v.pause(); to(e.clientX); try { st.setPointerCapture(e.pointerId); } catch (err) {} });
    st.addEventListener('pointermove', function (e) { if (drag) to(e.clientX); });
    function end() { if (!drag) return; drag = false; st.classList.remove('is-dragging'); if (!reduce) v.play().catch(function () {}); }
    st.addEventListener('pointerup', end); st.addEventListener('pointercancel', end); st.addEventListener('lostpointercapture', end);
    v.addEventListener('timeupdate', function () { if (bar && v.duration) bar.style.width = (v.currentTime / v.duration * 100) + '%'; });
  });
})();
